import Flickity from 'flickity';

const carousels = [];

export default function () {
  // Check if there are more than one article slides
  if (document.querySelectorAll('.BlogMainInterrupterCarousel__article-slide').length <= 1) {
    return;
  }

  document.querySelectorAll('[data-blog-interrupter-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }
    if (el.children.length === 0) {
      return;
    }

    el.setAttribute('initialized', 'true');

    const carousel = new Flickity(el, {});

    carousels.push(carousel);
  });
}
